export const validationNumber = (evt: any) => {
  (evt.key === "-" || evt.key === "+" || evt.key === "e" || evt.key === "E") &&
    evt.preventDefault();
};

export const disableCopy = (e: any) => {
  e.preventDefault();
  return false;
};

export const disablePaste = (e: any) => {
  if (/[^0-9 ]/.test(e.clipboardData.getData("text"))) {
    e.preventDefault();
    return;
  }
};
